import { useCallback } from 'react';

import type { UUID } from '@aline/common';
import { useCreatePhase } from 'src/hooks/phase';

interface AddPhaseOptions {
  isSigning: boolean;
  // Where to insert it; the end of the list when left out.
  order?: number;
}

/** Creates a phase in the workflow and resolves to its id, or null when the create failed. */
export function useAddPhase(workflowId: UUID) {
  const { createPhase, loading } = useCreatePhase();
  const addPhase = useCallback(
    async ({ isSigning, order }: AddPhaseOptions) => {
      const result = await createPhase({
        variables: {
          input: { isSigning, name: isSigning ? 'Signing Phase' : '', order, workflowId },
        },
      });
      return result.data?.createPhase?.phase?.id ?? null;
    },
    [createPhase, workflowId]
  );
  return { addPhase, loading };
}
